/**
 * Hook to fetch workspace users
 */

import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { User, usersApi } from "../api";

export const useUsers = (): UseQueryResult<User[], Error> => {
  return useQuery<User[], Error>({
    queryKey: ["ai-studio", "users"],
    queryFn: () => usersApi.list(),
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 2
  });
};

export const useUser = (userId?: string): UseQueryResult<User, Error> => {
  return useQuery<User, Error>({
    queryKey: ["ai-studio", "users", userId],
    queryFn: () => usersApi.get(userId!),
    enabled: !!userId,
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 2
  });
};
